import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
// import { isMobile } from '../lib/util';
import './Tabs.css';
import classnames from 'classnames';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';

class Tabs extends Component {
  state = {
    dropdownActive: false,
  };

  handleClickOutside = (evt) => {
    // ..handling code goes here...
    this.closeDropdown();
  };

  expandDropdown = () => {
    this.setState({ dropdownActive: true });
  };

  closeDropdown = () => {
    this.setState({ dropdownActive: false });
  };

  render() {
    const { tabs, match } = this.props;
    // const tabsMap = new Map(tabs.map(elem => [elem.stateIdentifier, elem.title]));
    const currentIdentifier = typeof match.params.filter === 'undefined' ? null : match.params.filter;
    
    // if (isMobile()) {
    //   return (
    //     <div
    //       className={`dropdown ${this.state.dropdownActive ? 'is-active' : ''}`}
    //       onFocus={this.expandDropdown}
    //     >
    //       <div className="dropdown-trigger">
    //         <button
    //           className="button is-primary"
    //           aria-haspopup="true"
    //           aria-controls="dropdown-menu"
    //         >
    //           <span id="currentTab">{tabsMap.get(currentIdentifier)}</span>
    //           <span className="icon is-small">
    //             <i className="fas fa-angle-down" aria-hidden="true" />
    //           </span>
    //         </button>
    //       </div>
    //       <div className="dropdown-menu" id="dropdown-menu" role="menu">
    //         <div className="dropdown-content">
    //           {tabs.map((elem, index) => (
    //             <Link key={index} className="dropdown-item" to={elem.link} onClick={this.closeDropdown}>
    //               {elem.title}
    //             </Link>
    //           ))}
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }
    
    return (
      <div className={classnames({
        tabs: true,
        "is-centered": true, 
        "is-toggle": !this.props.notToggle
      })}>
        <ul>
          {tabs.map((elem, idx) => (
            <li
              key={`tab-${idx}`}
              className={currentIdentifier === elem.stateIdentifier ? 'is-active' : ''}
            >
              <Link to={elem.link}>
                <FontAwesomeIcon className="tabs-icon" icon={faAngleRight} />
                <span>{elem.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      aboutpage: PropTypes.string,
    }),
  }).isRequired,
};

export default onClickOutside(Tabs);



// WEBPACK FOOTER //
// ./src/components/Tabs.js